var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page noselect",
      class: { withSearchbar: _vm.$store.getters.searchIsRenderedNow },
    },
    [
      _c("div", { staticClass: "spacer-25" }),
      _c("AllCategories"),
      _c("FixBasket"),
      _vm.$store.getters.isKiosk
        ? _c(
            "div",
            { staticClass: "pt-10 text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn-mini neuStartenScale12",
                  attrs: { rounded: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit("resetKioskReload")
                    },
                  },
                },
                [_vm._v(" NEU STARTEN ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }